<template lang='pug'>
  div
    h3
      |Demographie
      |
      small(v-if='averageAge') Ø-Alter {{averageAge}}
    chart(:type='type' :params='params||{}' :options='options' :benchmark-options='benchmarkOptions' :benchmarkOpen='benchmarkOpen' :benchmarkEnabled='benchmarkEnabled' :public='public')
</template>

<script>
import Chart from '../Chart.vue';
import Config from 'next_report/config'
import Highcharts from 'highcharts';

const agePyramid = (series, categories, max, percent) => {
  return Config.baseChart(percent, series, {
    chart: { type: 'bar' },
    xAxis: {
      categories: categories.map(el => el.replace("<", "&lt;")),
    },
    tooltip: Config.chartTemplates.unstackedTooltip(percent),
    plotOptions: {
      bar: { dataLabels: Config.chartTemplates.dataLabels(percent) },
      series: {
        stacking: 'normal'
      }
    },
    yAxis: {
      plotBands: [{
        color: "rgba(0,0,0,0.0)",
        from: -max,
        to: 0,
        zIndex: 2,
        label: {
          style: { fontSize: '22px', color: '#aaa' },
          text: "Männlich",
        }
      }, {
        color: "rgba(0,0,0,0.0)",
        from: 0,
        to: max,
        zIndex: 2,
        label: {
          style: { fontSize: '22px', color: '#aaa' },
          text: "Weiblich",
        }
      }],
      max: max,
      plotLines: [{
        color: '#000000',
        width: 1,
        value: 0,
        zIndex: 5,
      }],
      min: -max,
      allowDecimals: false,
      labels: {
        formatter() {
          if(percent) {
            return Math.abs(this.value) + "%";
          } else {
            return Math.abs(this.value)
          };
        }
      }
    }
  })
  return json;
}

export default {
  data() { return { averageAge: null }},
  props: ['type', 'color', 'params', 'benchmarkOpen', 'benchmarkEnabled', 'public'],
  computed: {
    firstColor() {
      return this.color || Config.colors.own[0]
    },
    secondColor() {
      if(this.color) {
        var obj = Highcharts.Color(this.color);
        return obj.brighten(0.2).get();
      } else {
        return Config.colors.own[1];
      }
    }
  },
  methods: {
    benchmarkOptions(response) {
      this.averageAge = response.average_age
      const categories = Object.keys(response.data["Männlich"])
      const series = [
        {
          name: 'Männlich (Eigene)',
          data: Object.values(response.data["Männlich"]).map(el => -el.percentage),
          color: this.firstColor,
          stack: 'eigene'
        },
        {
          name: 'Weiblich (Eigene)',
          data: Object.values(response.data["Weiblich"]).map(el => el.percentage),
          color: this.secondColor,
          stack: 'eigene'
        },
        {
          name: 'Männlich (Alle)',
          data: Object.values(response.benchmark_data["Männlich"]).map(el => -el.percentage),
          color: Config.colors.community[0],
          stack: 'alle'
        },
        {
          name: 'Weiblich (Alle)',
          data: Object.values(response.benchmark_data["Weiblich"]).map(el => el.percentage),
          color: Config.colors.community[1],
          stack: 'alle'
        }
      ]
      const values = Array.prototype.concat(...series.map(el => el.data)).map(el => Math.abs(el))
      const max = Math.max.apply(this, values) + 10;
      return agePyramid(series, categories, max, true)
    },
    options(response) {
      this.averageAge = response.average_age
      const female = Object.values(response.data["Weiblich"]).map(el => el.count)
      const male = Object.values(response.data["Männlich"]).map(el => el.count)
      const max = Math.max.apply(this, female.concat(male)) + 1;
      const categories = Object.keys(response.data["Männlich"])
      const series = [
        {
          name: 'Männlich',
          data: male.map(el => -el),
          color: this.firstColor,
        },
        {
          name: 'Weiblich',
          data: female,
          color: this.secondColor,
        }
      ]
      return agePyramid(series, categories, max, false)
    },
  },
  components: { Chart }
}
</script>
